export default __webpack_public_path__ + "static/media/Tualet1.1eba6a1e.png";